import {
  Button,
  Card,
  HeaderWithAlert,
  Select,
  SuccessAlert,
  ErrorAlert,
} from 'components';
import { IDetailStep } from 'models';
import { useSellInsuranceMassivelyIdentifier } from './hooks/useSellInsuranceMassivelyIdentifier';
import './SellInsuranceMassivelyIdentifier.scss';

export const SellInsuranceMassivelyIdentifier = () => {
  const {
    identifiersRaw,
    setIdentifiersRaw,
    keyCampaign,
    setKeyCampaign,
    campaignOptions,
    loadingCampaigns,
    isSubmitting,
    invalidIdentifiers,
    successMessage,
    setSuccessMessage,
    successResult,
    clearSuccessResult,
    errorMessage,
    setErrorMessage,
    setCampaignTouched,
    campaignError,
    handleSubmit,
    handleBack,
  } = useSellInsuranceMassivelyIdentifier();

  const steps: IDetailStep[] = [
    {
      description: 'ajustes',
      state: 'active',
      link: '/settings',
      permissionToNavigate: true,
    },
    {
      description: 'generar links de pago',
      state: 'active',
      link: '/settings/sell-insurance-massively-identifier',
      permissionToNavigate: false,
    },
  ];

  return (
    <>
      <HeaderWithAlert
        title=""
        message=""
        steps={steps}
        showAlert={undefined}
        onClick={handleBack}
      />

      <section className="sell-insurance-massively-identifier__container">
        <div className="sell-insurance-massively-identifier__content">
          <Card WrapperClassName="sell-insurance-massively-identifier__card">
            <div className="sell-insurance-massively-identifier__header">
              <h2 className="sell-insurance-massively-identifier__title">
                Generar links de pago
              </h2>
              <p className="sell-insurance-massively-identifier__description">
                Ingresa identificadores separados por coma (email, hubspot id,
                authId, etc.). Se generarán links de pago para la campaña
                seleccionada.
              </p>
            </div>

            <div className="sell-insurance-massively-identifier__form">
              <div className="sell-insurance-massively-identifier__field">
                <label
                  className="sell-insurance-massively-identifier__label"
                  htmlFor="identifiers"
                >
                  Identificadores (separados por coma)
                </label>
                <textarea
                  id="identifiers"
                  name="identifiers"
                  className="sell-insurance-massively-identifier__textarea"
                  placeholder="hubspot123, hubspot456, hubspot789..."
                  value={identifiersRaw}
                  onChange={(e) => setIdentifiersRaw(e.target.value)}
                  rows={6}
                  disabled={loadingCampaigns || isSubmitting}
                />
                {invalidIdentifiers.length > 0 && (
                  <p
                    className="sell-insurance-massively-identifier__error"
                    role="alert"
                  >
                    Identificadores no válidos: {invalidIdentifiers.join(', ')}
                  </p>
                )}
              </div>

              <div className="sell-insurance-massively-identifier__field">
                <Select
                  name="campaign"
                  id="campaign"
                  placeholder="Selecciona la campaña"
                  options={campaignOptions}
                  value={keyCampaign}
                  onClick={(value) => setKeyCampaign(value)}
                  onBlur={() => setCampaignTouched(true)}
                  WrapperClassName="sell-insurance-massively-identifier__select"
                  errorSelect={campaignError}
                  isTouched={campaignError !== undefined}
                  isRequired
                  isDisabled={loadingCampaigns || isSubmitting}
                />
              </div>

              <div className="sell-insurance-massively-identifier__actions">
                <Button
                  template="secondary"
                  typeStyle="square"
                  color="primary"
                  size="medium"
                  onClick={handleBack}
                  isDisabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button
                  template="primary"
                  typeStyle="square"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  isDisabled={
                    loadingCampaigns ||
                    isSubmitting ||
                    !identifiersRaw.trim() ||
                    !keyCampaign
                  }
                  isLoading={isSubmitting}
                >
                  Enviar
                </Button>
              </div>
            </div>
          </Card>
        </div>

        {successResult && (
          <Card WrapperClassName="sell-insurance-massively-identifier__result-card">
            <div className="sell-insurance-massively-identifier__result-header">
              <div className="sell-insurance-massively-identifier__result-header-text">
                <h3 className="sell-insurance-massively-identifier__result-title">
                  Resultado del envío
                </h3>
                <p className="sell-insurance-massively-identifier__result-intro">
                  Revisa qué identificadores se enviaron correctamente y cuáles
                  no.
                </p>
              </div>
              <div className="sell-insurance-massively-identifier__result-close-wrap">
                <Button
                  template="secondary"
                  typeStyle="square"
                  color="primary"
                  size="medium"
                  onClick={clearSuccessResult}
                  className="sell-insurance-massively-identifier__result-close-btn"
                >
                  Cerrar resultado
                </Button>
              </div>
            </div>
            <div className="sell-insurance-massively-identifier__result-body">
              {successResult.successfulIdentifiers.length > 0 && (
                <div className="sell-insurance-massively-identifier__result-block">
                  <h4 className="sell-insurance-massively-identifier__result-subtitle">
                    Enviados correctamente (
                    {successResult.successfulIdentifiers.length})
                  </h4>
                  <ul className="sell-insurance-massively-identifier__result-list sell-insurance-massively-identifier__result-list--success">
                    {successResult.successfulIdentifiers.map((id) => (
                      <li key={id}>{id}</li>
                    ))}
                  </ul>
                </div>
              )}
              {successResult.failedIdentifiers.length > 0 && (
                <div className="sell-insurance-massively-identifier__result-block">
                  <h4 className="sell-insurance-massively-identifier__result-subtitle">
                    No enviados ({successResult.failedIdentifiers.length})
                  </h4>
                  <ul className="sell-insurance-massively-identifier__result-list sell-insurance-massively-identifier__result-list--failed">
                    {successResult.failedIdentifiers.map(
                      ({ identifier, reason }) => (
                        <li key={identifier}>
                          <span className="sell-insurance-massively-identifier__result-identifier">
                            {identifier}
                          </span>
                          <span className="sell-insurance-massively-identifier__result-reason">
                            {reason}
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              )}
            </div>
          </Card>
        )}

        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage('')}
            isOpen
            title="Envío realizado"
          />
        )}

        {errorMessage && (
          <ErrorAlert
            message={errorMessage}
            onClose={() => setErrorMessage('')}
            isOpen
            title="Error"
          />
        )}
      </section>
    </>
  );
};
